<template>
  <div>
    <div :class="theContactShow ? 'contact-shadow fixed-wrap' : ''"></div>
    <div class="wrap">
      <!-- 自定义导航栏 -->
      <Nav v-if="navShow"></Nav>
      <!-- 自定义导航栏 -->
      <!--登录-->
      <div class="login-wrap">
        <!-- <img class="login-back-img" src="../../../assets/img/home_poster.png" alt=""> -->
        <div class="login-box">
          <div class="login-margin">
            <el-row>
              <el-col :span="12">
                <div>
                  <img
                    style="height: 360px"
                    src="../../../assets/img/zitu.png"
                    alt=""
                  />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="login-action" v-if="!$store.getters.isLogin">
                  <div class="login-padding">
                    <div class="login-title">登录</div>
                    <div class="input-wrap" :style="errorInfo.mobileWrapObj">
                      <img
                        src="../../../assets/img/login_btn_user.png"
                        alt=""
                      />
                      <input
                        type="text"
                        placeholder="请输入手机号"
                        v-model.trim="nickname"
                        @blur="checkNickname"
                      />
                      <img
                        v-show="nickname"
                        src="../../../assets/img/login_btn_cancel.png"
                        alt=""
                        @click="clear('nickname')"
                      />
                    </div>
                    <div class="input-tip" :style="errorInfo.mobileTipObj">
                      <Icon type="md-alert" size="24" color="#FF4F76" />
                      <span class="tip-content">{{ errorInfo.mobileTip }}</span>
                    </div>
                    <div
                      class="input-wrap last"
                      :style="errorInfo.passwordWrapObj"
                    >
                      <img
                        src="../../../assets/img/login_btn_password.png"
                        alt=""
                      />
                      <input
                        type="password"
                        placeholder="请输入密码"
                        v-model.trim="password"
                        @input="checkPassword"
                      />
                      <img
                        v-show="password"
                        src="../../../assets/img/login_btn_cancel.png"
                        alt=""
                        @click="clear('password')"
                      />
                    </div>
                    <div class="input-tip" :style="errorInfo.passwordTipObj">
                      <Icon type="md-alert" size="24" color="#FF4F76" />
                      <span class="tip-content">{{
                        errorInfo.passwordTip
                      }}</span>
                    </div>
                    <div class="operate-wrap">
                      <div class="forget-pwd" @click="toForgetPwd">
                        忘记密码？
                      </div>
                      <div class="to-register" @click="toRegister">
                        注册账号
                      </div>
                    </div>
                    <div class="to-login" @click="doLogin">登录</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 为什么选择我们-->
      <div class="advantage-wrap">
        <div class="advantage-box">
          <div class="advantage-title">为什么选择我们</div>
          <div class="advantage-img">
            <img src="../../../assets/img/home_banner.png" alt="" />
          </div>
          <div class="content-list">
            <div class="adv-padding-left">
              <div class="adv-wrap">
                <div class="adv-box">
                  <div class="adv-el-row">
                    <img
                      src="../../../assets/img/home_img_1.png"
                      alt=""
                      class="adv-img"
                    />
                    <div class="adv-text-box">
                      <div class="adv-title">全国电影票低至3折优惠多多</div>
                      <div class="adv-subtitle">支持3种购票模式</div>
                      <div class="adv-part">
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            <span>特惠购票：</span
                            >以淘票票原价的85-95折购票，任何影院均可享受优惠
                          </div>
                        </div>
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            <span>竞价模式：</span
                            >后台超100位供票商竞价，以最低竞价金额出票，低至3折。平均出票时间10分钟内
                          </div>
                        </div>
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            <span>秒出票：</span>原价购票，付款秒出票，无须等待
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="adv-padding-right">
              <div class="adv-wrap">
                <div class="adv-box">
                  <div class="adv-el-row">
                    <img
                      src="../../../assets/img/home_img_2.png"
                      alt=""
                      class="adv-img"
                    />
                    <div class="adv-text-box">
                      <div class="adv-title">覆盖全国98%以上的大小影院</div>
                      <div class="adv-part">
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            支持全国各地影院，购票建议优选全国连锁影院，如万达、大地、横店、万象、金逸、卢米埃等惠
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="adv-padding-left">
              <div class="adv-wrap">
                <div class="adv-box">
                  <div class="adv-el-row">
                    <img
                      src="../../../assets/img/home_img_3.png"
                      alt=""
                      class="adv-img"
                    />
                    <div class="adv-text-box">
                      <div class="adv-title">多种合作方案、满足各种需求</div>
                      <div class="adv-part">
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            专属H5公众号购票链接
                          </div>
                        </div>
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            三种购票模式，体验更佳
                          </div>
                        </div>
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            专属小程序购票，支持分销裂变
                          </div>
                        </div>
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            企业合作，适合任何形式，根据业务模式，独立开发APP、小程序、H5等相关产品
                          </div>
                        </div>
                        <!--                            <div class="adv-part-box">-->
                        <!--                              <div class="adv-part-circle"></div>-->
                        <!--                              <div class="adv-part-content">申请开放平台开发者，提供影院、影片、排期、选座、出票接口</div>-->
                        <!--                            </div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="adv-padding-right">
              <div class="adv-wrap">
                <div class="adv-box">
                  <div class="adv-el-row">
                    <img
                      src="../../../assets/img/home_img_4.png"
                      alt=""
                      class="adv-img"
                    />
                    <div class="adv-text-box">
                      <div class="adv-title">强大的售后团队7x24小时服务</div>
                      <div class="adv-part">
                        <div class="adv-part-box">
                          <div class="adv-part-circle"></div>
                          <div class="adv-part-content">
                            解决所有购票售后问题、一站式服务，全自动赚钱，无须担心售后问题，全程为您保驾护航
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 为什么选择我们-->
      <!-- 推广方式-->
      <div class="promotion-wrap">
        <div class="promotion-padding">
          <div class="promotion-title">4种推广方式任您选</div>
          <div class="swiper-wrap">
            <div>
              <el-row>
                <el-col :span="6">
                  <div class="pro-left">
                    <div class="pro-box">
                      <div class="pro-index">01</div>
                      <div>
                        <div class="pro-title">H5公众号购票链接</div>
                        <div class="league-box">
                          <span>加盟费：99元/年 - 499/年</span>
                        </div>
                        <div class="pro-des-box">
                          <div class="pro-des-div">
                            订单分润<span>80% - 100%</span>
                          </div>
                          <div class="pro-des-div">支持微信服务号模版推送</div>
                          <div class="pro-des-div">
                            轻松对接后即可推广，粉丝变现最佳选择
                          </div>
                          <div class="pro-des">放映2小时后结算</div>
                        </div>
                        <div class="pro-btn-box">
                          <span class="pro-btn" @click="contactUs()"
                            >我要赚钱</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="pro-middle">
                    <div class="pro-box">
                      <div class="pro-index">02</div>
                      <div style="">
                        <div class="pro-title">小程序购票链接</div>
                        <div class="league-box">
                          <span>加盟费：99元/年-499/年</span>
                        </div>
                        <div class="pro-des-box">
                          <div class="pro-des-div">
                            订单分润<span>80% - 100%</span>
                          </div>
                          <div class="pro-des-div">
                            需要企业号，独立小程序，支持分销自由比例分佣
                          </div>
                          <div class="pro-des-div">快速裂变粉丝</div>
                          <div class="pro-des-div">放映2小时后结算</div>
                        </div>
                        <div class="pro-btn-box">
                          <span class="pro-btn" @click="contactUs()"
                            >我要赚钱</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="pro-middle">
                    <div class="pro-box">
                      <div class="pro-index">03</div>
                      <div style="">
                        <div class="pro-title">API接入</div>
                        <div class="league-box">
                          <span>加盟费：3000元/年</span>
                        </div>
                        <div class="pro-des-box">
                          <div class="pro-des-div">
                            订单成本价供票（含3%技术服务费）
                          </div>
                          <div class="pro-des-div">
                            月订单量达到1000单，全额退还
                          </div>
                          <!--                          <div class="pro-des-div">全自动快速裂变粉丝</div>-->
                          <div class="pro-des-div">
                            适合任何形式，根据业务模式，独立开发APP，小程序，H5等相关产品
                          </div>
                        </div>
                        <div class="pro-btn-box">
                          <span class="pro-btn" @click="contactUs()"
                            >我要赚钱</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="pro-middle">
                    <div class="pro-box">
                      <div class="pro-index">04</div>
                      <div style="">
                        <div class="pro-title">抖音小程序推广</div>
                        <div class="league-box">
                          <span>要求：抖音粉丝≥1000</span>
                        </div>
                        <div class="pro-des-box">
                          <div class="pro-des-div">
                            推广小程序成交订单即可获得佣金
                          </div>
                          <div class="pro-des-div">助力粉丝流量变现</div>
                          <!--                          <div class="pro-des-div">全自动快速裂变粉丝</div>-->
                          <div class="pro-des-div">支持分销推广模式</div>
                        </div>
                        <div class="pro-btn-box">
                          <span class="pro-btn" @click="contactUs()"
                            >我要赚钱</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="self-el-item-swiper">
              <el-row> </el-row>
            </div>
          </div>

          <!--<div class="counselor-box">-->
          <!--<span class="counselor-btn"-->
          <!--@click="contactUs()">联系营销顾问</span>-->
          <!--</div>-->
        </div>
        <popup
          v-show="isShowContact"
          @chooseContact="handelChooseContact"
        ></popup>
      </div>
      <!-- 推广方式-->
      <!-- 加入我们-->
      <div class="joinus-wrap">
        <div class="joinus-padding">
          <div class="joinus-title">加入我们，赚取佣金</div>
          <div class="step-wrap">
            <el-row>
              <el-col :span="6">
                <div class="joinus-border">
                  <img
                    src="../../../assets/img/home_commission.png"
                    alt=""
                    style="width: 100%"
                  />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="step">STEP 1</div>
                <div class="step-img">
                  <img src="../../../assets/img/home_commission_1.png" alt="" />
                </div>
                <div class="step-text">注册账号</div>
              </el-col>
              <el-col :span="6">
                <div class="step">STEP 2</div>
                <div class="step-img">
                  <img src="../../../assets/img/home_commission_2.png" alt="" />
                </div>
                <div class="step-text">申请推广位并获取链接或海报</div>
              </el-col>
              <el-col :span="6">
                <div class="step">STEP 3</div>
                <div class="step-img">
                  <img src="../../../assets/img/home_commission_3.png" alt="" />
                </div>
                <div class="step-text">赚取佣金</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 加入我们-->
      <!-- 底部-->
      <Footer></Footer>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
    <!-- 产品与服务 -->
    <!-- <div v-if="false">
      <div class="dialog-bg"></div>
      <div class="service-wrap">
        <div class="flex-space-between header">
          <div class="title">产品与服务</div>
          <img src="~@/assets/img/pop_close.png" @click="closeDialog" />
        </div>
        <div class="flex-space-around body">
          <div class="zfb-bac service-item">
            <img
              class="zfb-bac-image"
              style="width: 160px"
              src="~@/assets/img/zfb-iamge.png"
            />
          </div>
          <div class="service-item">
            <img src="~@/assets/img/pop_icon_wdtgw_1.png" />
            <div class="title">我的API</div>
            <div class="sm-title">
              通过推广链接(二维码)，创建您的专属推广位 推广方式灵活便捷
            </div>
            <div class="btn-enter" @click="toEnter('promotion')">点击进入</div>
          </div>
          <div class="service-item">
            <img src="~@/assets/img/pop_icon_wdgzh_2.png" />
            <div class="title">我的公众号</div>
            <div class="sm-title">绑定公众号进行推广</div>
            <div class="sm-title">助力粉丝流量变现</div>
            <div class="btn-enter" @click="toEnter('official')">点击进入</div>
          </div>
          <div class="service-item">
            <img src="~@/assets/img/pop_icon_wdxcx_3.png" />
            <div class="title">我的小程序</div>
            <div class="sm-title">授权小程序进行推广</div>
            <div class="sm-title">助力粉丝流量变现</div>
            <div class="btn-enter" @click="toEnter('mini')">点击进入</div>
          </div>
          <div class="service-item" v-if="is_developer">
            <img src="~@/assets/img/pop_icon_wdyy_4.png" />
            <div class="title">我的应用</div>
            <div class="sm-title">查看接口key</div>
            <div class="sm-title">为应用提供接口服务</div>
            <div class="btn-enter" @click="toEnter('open')">点击进入</div>
          </div>
          <div class="service-item">
            <img src="~@/assets/img/pop_icon_wddytg_5.png" />
            <div class="title">我的抖音推广</div>
            <div class="sm-title">授权抖音小程序进行推广</div>
            <div class="sm-title">助力粉丝流量变现</div>
            <div class="btn-enter" @click="toEnter('douyin')">点击进入</div>
          </div>
          <div class="service-item">
            <img src="~@/assets/img/pop_icon_wddytg_5.png" />
            <div class="title">我的快手推广</div>
            <div class="sm-title">授权快手小程序进行推广</div>
            <div class="sm-title">助力粉丝流量变现</div>
            <div class="btn-enter" @click="toEnter('kuaishou')">点击进入</div>
          </div>
        </div>
      </div>
    </div> -->

    <div v-if="isShowDialog">
      <div class="dialog-bg"></div>
      <div class="pop-wraps">
        <div class="top">
          <div class="title">产品与服务</div>
          <img
            class="ca"
            src="~@/assets/img/pop_close.png"
            @click="closeDialog"
          />
        </div>
        <div class="banner-container">
          <div class="contents">
            <div class="banner-content">
              <div class="banner-content-l">
                <div class="title">支付宝小程序上线啦！</div>
                <div class="text-s"> 
                  <span>低门槛</span>
                  <span>30天内免费对接,独立部署</span>
                  <span>|</span>
                  <span>高佣金</span>
                  <span>
                    <span class="red">100%</span><span>分佣,利润</span><span class="red">10%-18%</span>
                  </span>
                </div>
                <div class="text-t">
                  <span>重磅福利</span>
                  <span>
                    <span>部署后</span><span class="red">30天</span><span>内免</span><span class="red">3%</span><span>服务费</span>
                  </span>
                </div>
              </div>
              <div class="banner-content-r">
                <div class="left">
                  <div class="iamges">
                    <img
                      v-if="isSaasProxyUser == 1"
                      class="images1"
                      src="https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240628171038.png"
                    />
                    <img
                      v-else
                      src="https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/pop_qrcode_1.png"
                    />
                  </div>
                  <div class="text">加入联系我们</div>
                </div>
                <div class="right">
                  <div class="iamges">
                    <img
                      src="https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/pop_qrcode_2.png"
                      alt=""
                    />
                  </div>
                  <div class="text">支付宝扫码体验</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dia-list">
          <div v-for="(item,index) in routerList" :key="index" class="items">
            <div class="tops">
              <img class="tops-img" :src="require(`../../../assets/img/home/${item.imgUrl}.png`)" alt="">
              <!-- <img class="tops-img" src="../../../assets/img/home/pop_icon_zfb_5.png" alt=""> -->
              <div class="tops-btn" @click="toEnter(item.url)">点击进入</div>
            </div>
            <div class="botom">
              <div class="botom-title">{{item.title}}</div>
              <div class="botom-text">{{item.text}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品与服务 -->
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Popup from "@/components/Popup.vue";
import Footer from "@/components/Footer.vue";
import { Spin, Icon, Modal } from "view-design";
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
  EffectCoverflow,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";

const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
  EffectCoverflow,
]);
import { getToken } from "@/utils/auth";
import { login } from "@/api/user";

export default {
  name: "Home",
  components: {
    Nav,
    Popup,
    Footer,
    Swiper,
    SwiperSlide,
    Spin,
    Icon,
  },
  data() {
    //var __that = this
    return {
      routerList:[
        {
          imgUrl:'pop_icon_api_1',
          title:'我的API',
          text:'通过推广链接(二维码)，创建您的专属推广位 推广方式灵活便捷',
          url:'promotion'
        },
        {
          imgUrl:'pop_icon_dy_3',
          title:'我的抖音推广',
          text:'授权抖音小程序进行推广，助力粉丝流量变现',
          url:'douyin'
        },
        {
          imgUrl:'pop_icon_wx_7',
          title:'我的微信小程序',
          text:'授权小程序进行推广，助力粉丝流量变现',
          url:'mini'
        },
        {
          imgUrl:'pop_icon_gzh_4',
          title:'我的公众号',
          text:'绑定公众号进行推广，助力粉丝流量变现',
          url:'official'
        },
        {
          imgUrl:'pop_icon_zfb_5',
          title:'我的支付宝小程序',
          text:'授权支付宝小程序进行推广，助力粉丝流量变现',
          url:'zfbMiniProgram'
        },
        {
          imgUrl:'pop_icon_ks_2',
          title:'我的快手推广',
          text:'授权快手小程序进行推广，助力粉丝流量变现',
          url:'kuaishou'
        },
        {
          imgUrl:'pop_icon_yy_6',
          title:'我的应用',
          text:'查看接口key，为应用提供接口服务',
          url:'open'
        },
        
      ],
      advantageHeight: 0,
      nickname: "",
      password: "",
      code: "",
      swiperActiveIndex: 1,
      active: false,
      isDoing: false,
      loading: false,
      isAutoSwiper: true,
      swiperOption: {
        loop: true, //循环
        direction: "horizontal",
        //自动播放的相关设置
        // autoplay: {
        //   delay: 2500,//2.5秒切换一次
        //   stopOnLastSlide: false,
        //   //设置触碰后是否停止自动播放
        //   disableOnInteraction: false
        // },
        autoplay: false,
        //滑动速度
        speed: 2500,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        paginationClickable: true,
        /*// 切换器-设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },*/
        //修改swiper自己或子元素时，自动初始化swiper
        observer: true,
        //修改swiper的父元素时，自动初始化swiper
        observeParents: true,
        on: {
          click: function (swiper, event) {
            console.log(swiper);
            console.log(event);
          },
        },
      },
      isLogin: getToken() ? true : false, //是否登陆
      isShowContact: false,
      errorInfo: {
        mobileTip: "",
        passwordTip: "",
        mobileTipObj: {
          display: "none",
        },
        passwordTipObj: {
          display: "none",
        },
        mobileWrapObj: {
          border: "1px solid #eeeeee",
        },
        passwordWrapObj: {
          border: "1px solid #eeeeee", // ff4f76
        },
      },
      openUserInfo: {}, // 开放平台登录信息
      navShow: true,
    };
  },
  computed: {
    isSaasProxyUser: function () {
      return this.$store.getters.isSaasProxyUser;
    },
    isDyAppOwner: function () {
      return this.$store.getters.isDyAppOwner;
    },
    theContactShow: function () {
      return this.isShowContact;
    },
    is_developer: function () {
      return this.$store.getters.isDeveloper;
    },
    isShowDialog() {
      if (this.$store.getters.isLogin && this.$store.getters.movieShowDialog) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    if (this.$route.query.invite_code) {
      let inviteCode = this.$route.query.invite_code;
      localStorage.setItem("inviteCode", inviteCode);
    }
    if (this.$store.getters.isLogin) {
      this.$store.dispatch("nav/changeMovieShowDialog", true);
    }
    let isSaas = this.$route.query;
    // 判断是否可以显示saas
    if (isSaas.type == "saasmovie") {
      localStorage.setItem("isSaas", 1);
    } else {
      localStorage.setItem("isSaas", 0);
    }
    this.openUserInfo = localStorage.getItem("openUserInfo");
    console.log(localStorage.getItem("openUserInfo"),'this.openUserInfo')
    if (localStorage.getItem("leadUUID")) {
      let leadUUID = localStorage.getItem("leadUUID");
      if (leadUUID != 0) {
        this.$router.push({
          path: "/pc/bypassAccountOrder/ApiOrder",
        });
      }
    }
  },
  methods: {
    //清除文本框
    clear(val) {
      this[val] = "";
    },
    //监听密码
    checkPassword() {
      var isValidate = true;
      var tip = "";
      if (this.password === "") {
        tip = "请填写密码";
        isValidate = false;
        return this.handelErrorTip(isValidate, 1, tip);
      }
      if (!(this.password.length >= 6)) {
        tip = "密码长度错误";
        isValidate = false;
        return this.handelErrorTip(isValidate, 1, tip);
      }
      tip = "";
      isValidate = true;
      return this.handelErrorTip(isValidate, 1, tip);
    },
    //监听昵称或手机号
    checkNickname() {
      var isValidate = true;
      var tip = "";
      if (this.nickname === "") {
        tip = "请填写手机号";
        isValidate = false;
        return this.handelErrorTip(isValidate, 0, tip);
      }
      var numReg = /^[0-9]*$/;
      var numRe = new RegExp(numReg);
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.nickname)) {
        tip = "手机号格式错误";
        isValidate = false;
        return this.handelErrorTip(isValidate, 0, tip);
      }
      isValidate = true;
      tip = "";
      return this.handelErrorTip(isValidate, 0, tip);
    },
    handelErrorTip: function (isValidate, type, tip) {
      if (type == 0) {
        if (isValidate === false) {
          this.errorInfo.mobileTip = tip;
          this.errorInfo.mobileTipObj.display = "flex";
          this.errorInfo.mobileWrapObj.border = "1px solid #ff4f76";
        } else {
          this.errorInfo.mobileTip = "";
          this.errorInfo.mobileTipObj.display = "none";
          this.errorInfo.mobileWrapObj.border = "1px solid #eee";
        }
      } else {
        if (isValidate === false) {
          this.errorInfo.passwordTip = tip;
          this.errorInfo.passwordTipObj.display = "flex";
          this.errorInfo.passwordWrapObj.border = "1px solid #ff4f76";
        } else {
          this.errorInfo.passwordTip = "";
          this.errorInfo.passwordTipObj.display = "none";
          this.errorInfo.passwordWrapObj.border = "1px solid #eee";
        }
      }
      return isValidate;
    },
    // getAdvantageBoxHeight: function () {
    //   this.advantageHeight = this.$refs.advantage_box.$el.offsetHeight - 40 + 'px'
    // },
    //跳转到登录界面
    toRegister() {
      this.$router.push("/pc/register");
    },
    toForgetPwd() {
      this.$router.push("/pc/resetPwd");
    },
    //联系我们弹窗
    contactUs() {
      this.isShowContact = !this.isShowContact;
    },
    doLogin() {
      var isValidate = this.allValidate();
      if (isValidate === false) {
        return;
      }
      var loginFormData = {
        mobile: this.nickname,
        password: this.password,
      };
      this.$store
        .dispatch("user/login", loginFormData)
        .then((response) => {
          let userInfo = response.data.userInfo;
          if (userInfo.saas_dy_app_url && this.$domain !== "localhost:8080") {
            this.$store.commit("user/SET_ISLOGIN", false);
            this.$confirm(userInfo.saas_dy_app_tip, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$store.dispatch("nav/changeIsGoOfficial", 0);
                this.$store.dispatch("user/logout");
                this.$Message.success("退出成功");
                localStorage.removeItem("java-token");
                localStorage.removeItem("java-open-token");
                this.$store.commit("user/SET_APP_TYPE", {
                  isSaasProxyUser: 0,
                  isDyAppOwner: 0,
                });
                this.$store.commit("user/SET_TOKEN", "");
                this.$store.commit("user/SET_NICKNAME", "");
                // window.location.href = userInfo.saas_dy_app_url
                window.open(userInfo.saas_dy_app_url);
              })
              .catch(() => {
                this.$store.dispatch("nav/changeIsGoOfficial", 0);
                this.$store.dispatch("user/logout");
                this.$router.push({
                  path: "/",
                });
              });
            return;
          }
          this.$store.commit("user/SET_APP_TYPE", {
            isSaasProxyUser: userInfo.is_saas_proxy_user,
            isDyAppOwner: userInfo.is_dy_app_owner,
          });
          this.loading = false;
          this.isLogin = true;
          this.nickname = this.password = "";
          this.$Message.success("登录成功");
          let miniAppType = localStorage.getItem("miniAppType");
          console.log(miniAppType, "登录成功==删除miniAppTypeAAA");
          localStorage.removeItem("miniAppType");
          localStorage.removeItem("miniAppTypeZfb");
          // if (miniAppType) {
            
          // }
          localStorage.setItem("leadUUID", userInfo.leadUUID);
          if (userInfo.leadUUID != 0) {
            this.$router.push({
              path: "/pc/bypassAccountOrder/ApiOrder",
            });
          }
          this.$store.dispatch("nav/changeMovieShowDialog", true);
          //获取用户信息
          // this.$store.dispatch('user/getInfo').then((response) => {
          //   // 如果之前用户从公众号那边入驻进来的
          //
          //   let isGoOfficial = this.$store.getters.isGoOfficial
          //   if(isGoOfficial == 1){
          //     let param = this.$route.param
          //     // 是否购买了套餐
          //     let hasPackage =   getHasPackage() === 'true' ? true : false
          //     if(hasPackage){
          //       this.$store.dispatch('nav/changeOfficialAccountActiveIndex',0)
          //       this.$router.push({
          //         path: '/pc/official/statistics',
          //         query:param
          //       })
          //     }else{
          //       this.$store.dispatch('nav/changeOfficialAccountActiveIndex',0)
          //       // 便于sildeNav 触发change数据
          //       this.$router.push({
          //         path: '/pc/official/dialog',
          //         query:param
          //       })
          //     }
          //   }else{
          //     this.$router.push({
          //       path: '/pc/promotion/home',
          //       query: this.otherQuery
          //     })
          //   }
          //
          // }).catch(() => {})
        })
        .catch((e) => {
          console.log("debug:________________e______________", e);
          this.loading = false;
        });
    },
    allValidate() {
      return this.checkNickname() && this.checkPassword();
    },
    handelChooseContact() {
      this.isShowContact = false;
    },
    toEnter(type) {
      let that = this;
      var token = getToken();
      console.log("token", token);
      if (token === undefined || token === "") {
        // 弹窗提示
        Modal.warning({
          title: "提示",
          content: "您还未登录或登录过期，请重新登录！",
          onOk: function () {
            that.$store.dispatch("nav/changeActiveIndex", 0);
            if (type == 7 && isSaas == 1) {
              that.$router.push({
                path: "/",
                query: {
                  type: "saasmovie",
                },
              });
            } else {
              that.$router.push("/");
            }
            that.isLogin = false;
            that.$store.commit("user/SET_ISLOGIN", false);
          },
        });
      }
      let url = "";
      switch (type) {
        case "promotion":
          url = "/pc/promotion/home";
          this.$store.commit("nav/SET_SELECT_ITEM", 0);
          localStorage.setItem("isSelect", 0);
          break;
        case "official":
          this.$store.commit("nav/SET_SELECT_ITEM", 1);
          localStorage.setItem("isSelect", 1);
          url = "/pc/official/statistics";
          this.$store.dispatch("nav/changeMovieShowDialog", true);
          this.$store.dispatch("nav/changeOfficialAccountActiveIndex", 0);
          break;
        case "open":
          url = "/pc/document/user";
          break;
        case "mini":
          localStorage.setItem("isSelect", 2);
          this.$store.commit("nav/SET_SELECT_ITEM", 2);
          url = "/pc/miniProgram/home";
          break;
        case "zfbMiniProgram":
          localStorage.setItem("isSelect", 3);
          this.$store.commit("nav/SET_SELECT_ITEM", 3);
          url = "/pc/zfbMiniProgram/home";
          break;
        case "douyin":
          // 好影分销代理
          if(this.isSaasProxyUser !== 0 && this.isDyAppOwner !== 1) {
            localStorage.setItem("isSelect", 0);
          }else{
            localStorage.setItem("isSelect", 4);
          }
          url = "/pc/douyin/home/index";
          break;
        case "kuaishou":
          if(this.isSaasProxyUser !== 0 && this.isDyAppOwner !== 1) {
            localStorage.setItem("isSelect", 1);
          }else{
            localStorage.setItem("isSelect", 5);
          }
          url = "/pc/kuaishou/home/index";
          break;
      }
      this.$router.push(url);
    },
    // 关闭弹窗
    closeDialog() {
      this.$store.dispatch("nav/changeMovieShowDialog", false);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.fixed-wrap {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

>>> .ivu-spin-dot {
  background: #ff8622;
}

.self-el-item-swiper {
  margin-top: 24px;
  /*margin-bottom: 1rem;*/
}

.wrap {
  min-width: 850px;
}

/* 登录*/
.login-wrap {
  min-height: 560px;
  background-image: url(../../../assets/img/home_poster.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
}

/* .login-wrap .login-back-img{
  width: 100%;
  min-height: 500px;
} */
.login-wrap .login-box {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.login-wrap .login-action {
  background: #ffffff;
  width: 380px;
  height: 380px;
  float: right;
}

.login-wrap .login-action .login-padding {
  padding: 30px 60px;
}

.login-wrap .login-action .login-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 32px;
  color: #222222;
  line-height: 80px;
  text-align: center;
}

.login-wrap .login-action .input-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 10px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-top: 20px;
}

.login-wrap .login-action .input-wrap img {
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.login-wrap .login-action .input-wrap input {
  width: 90%;
  font-size: 14px;
  color: #222222;
  padding: 5px;
  border: none;
}

.login-wrap .login-action .input-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #ff4f76;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.login-wrap .login-action .input-tip.hidden {
  display: none;
}

.login-wrap .login-action .input-tip .tip-content {
  margin-left: 3px;
  color: #ff4f76;
}

::-webkit-input-placeholder {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}

.operate-wrap {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  margin-top: 16px;
  width: 100%;
  overflow: hidden;
}

.operate-wrap .forget-pwd {
  float: left;
  cursor: pointer;
}

.operate-wrap .to-register {
  float: right;
  cursor: pointer;
}

.to-login {
  color: #ffffff;
  background: #ff9734;
  border-radius: 2px;
  margin-top: 20px;
  text-align: center;
  height: 48px;
  line-height: 48px;
  cursor: pointer;
}

/* 登录*/
/* 公告*/
.notice-wrap {
  background: #f2f2f2;
  height: 48px;
  line-height: 48px;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #666666;
}

.notice-wrap .notice-box {
  margin: auto 15%;
}

.notice-wrap .notice-box .el-row {
  width: 100%;
  height: 48px;
  overflow: hidden;
}

.notice-wrap .notice-box img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}

/* 公告*/
/* 优势*/
.advantage-wrap {
  padding: 50px 0;
  background: #ffffff;
}

.advantage-wrap .advantage-box {
  margin: auto 15%;
}

.advantage-wrap .advantage-box .advantage-title {
  text-align: center;
  font-family: Alibaba-PuHuiTi-M;
  font-size: 36px;
  color: #222222;
  letter-spacing: 0;
  padding: 10px 0 20px 0;
}

.advantage-wrap .advantage-box .advantage-img {
  text-align: center;
  padding: 20px 0;
}

.advantage-wrap .advantage-box .advantage-img img {
  vertical-align: middle;
  width: 100%;
}

.advantage-wrap .advantage-box .adv-padding-left {
  width: 50%;
}

.advantage-wrap .advantage-box .adv-padding-right {
  width: 50%;
}

.adv-wrap {
  border: 1px solid #eeeeee;
  display: flex;
  flex-flow: column wrap;
  margin: 10px;
}

.advantage-wrap .advantage-box .adv-box {
  height: 300px;
}

.advantage-wrap .advantage-box .adv-box .adv-el-row {
  padding: 24px;
  display: flex;
  /*align-items: center;*/
}

.advantage-wrap .advantage-box .adv-box .adv-text-box {
  padding-left: 20px;
}

.advantage-wrap .advantage-box .adv-box .adv-text-box .adv-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 22px;
  color: #222222;
}

.advantage-wrap .advantage-box .adv-box .adv-text-box .adv-subtitle {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #333333;
  text-align: justify;
  padding: 10px 0;
}

.advantage-wrap .advantage-box .adv-box .adv-text-box .adv-part {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #999999;
  text-align: justify;
  line-height: 20px;
}

.advantage-wrap .advantage-box .adv-box .adv-text-box .adv-part .adv-part-box {
  display: flex;
  flex-direction: row;
  padding: 2px 0;
}

.advantage-wrap
  .advantage-box
  .adv-box
  .adv-text-box
  .adv-part
  .adv-part-circle {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #ff9734;
  margin: 5px;
}

.advantage-wrap
  .advantage-box
  .adv-box
  .adv-text-box
  .adv-part
  .adv-part-content {
  width: 90%;
}

.advantage-wrap
  .advantage-box
  .adv-box
  .adv-text-box
  .adv-part
  .adv-part-content
  span {
  color: #666666;
}

/* 优势*/
/* 推广方式*/
.promotion-wrap {
  padding: 100px 0;
  background: #fafafa;
}

.promotion-wrap .promotion-padding {
  margin: auto 15%;
}

.promotion-wrap .promotion-padding .promotion-title {
  text-align: center;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 36px;
  color: #222222;
  letter-spacing: 0;
  padding: 0 0 70px 0;
}

.promotion-wrap .promotion-padding .pro-left {
  padding-right: 12px;
}

.promotion-wrap .promotion-padding .pro-middle {
  padding: 0 12px;
}

.promotion-wrap .promotion-padding .pro-right {
  padding-left: 12px;
}

.promotion-wrap .promotion-padding .pro-box {
  /*width: 380px;*/
  background: #ffffff;
  /*display: flex;*/
  flex-direction: row;
  /*padding: 40px 20px 20px 20px;*/
  padding: 30px;
  height: 400px;
}

.promotion-wrap .promotion-padding .pro-box .pro-index {
  width: 30px;
  padding-right: 9px;
  font-family: Alibaba-PuHuiTi-M;
  font-size: 28px;
  color: #dedede;
  letter-spacing: 0;
  text-align: justify;
  margin-right: 5px;
}

.promotion-wrap .promotion-padding .pro-box .pro-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 28px;
  color: #222222;
  letter-spacing: 0;
  text-align: justify;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
}

.promotion-wrap .promotion-padding .pro-box .league-box {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #ff8622;
  letter-spacing: 0;
  text-align: justify;
  margin: 10px 0 20px 0;
}

.promotion-wrap .promotion-padding .pro-box .league-box span {
  padding: 2px 4px;
  background: #fff8f2;
}

.promotion-wrap .promotion-padding .pro-box .pro-des-box {
  height: 150px;
  overflow: hidden;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #999a99;
  letter-spacing: 0;
  text-align: justify;
}

.promotion-wrap .promotion-padding .pro-box .pro-des-box .pro-des-div {
  line-height: 20px;
  padding: 2px 0;
}

.promotion-wrap .promotion-padding .pro-box .pro-des-box .pro-des-div span {
  color: #ff4f76;
  line-height: 20px;
}

.promotion-wrap .promotion-padding .pro-box .pro-btn-box {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #999a99;
  letter-spacing: 0;
  text-align: justify;
  line-height: 20px;
  /*margin: 30px 0;*/
  margin-top: 10px;
}

.promotion-wrap .promotion-padding .pro-box .pro-btn-box .pro-btn {
  padding: 5px 20px;
  background: #ff8622;
  color: #ffffff;
  cursor: pointer;
}

.promotion-wrap .promotion-padding .counselor-box {
  text-align: center;
  margin-top: 40px;
}

.promotion-wrap .promotion-padding .counselor-btn {
  background: #ff8622;
  color: #ffffff;
  padding: 8px 36px;
  cursor: pointer;
}

/* 推广方式*/
/* 加入我们*/
.joinus-wrap {
  padding: 100px 0;
  background: #ffffff;
}

.joinus-wrap .joinus-padding {
  margin: auto 15%;
}

.joinus-wrap .joinus-padding .joinus-title {
  text-align: center;
  font-family: Alibaba-PuHuiTi-M;
  font-size: 36px;
  color: #222222;
  letter-spacing: 0;
  padding-bottom: 50px;
}

.joinus-wrap .joinus-padding .step-wrap {
  border: 1px solid #eeeeee;
  height: auto;
  text-align: center;
}

.joinus-wrap .joinus-padding .step-wrap .el-row {
  display: flex;
  flex-wrap: wrap;
}

.joinus-wrap .joinus-padding .step-wrap .el-col {
  min-width: 25%;
  min-height: 100%;
  border-right: 1px solid #eeeeee;
}

.joinus-wrap .joinus-padding .step-wrap .el-col:last-child {
  border-right: none;
}

.joinus-wrap .joinus-padding .step-wrap .step {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 16px;
  color: #999999;
  letter-spacing: 0;
  text-align: left;
  padding: 15px 0 50px 15px;
}

.joinus-wrap .joinus-padding .step-wrap .step-img img {
  width: 60%;
  text-align: center;
  vertical-align: middle;
}

.joinus-wrap .joinus-padding .step-wrap .step-text {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 70px;
}

/* 加入我们*/
@media (min-width: 768px) {
  /* .login-wrap .login-action {
    margin-right: 7.5%;
  } */
  .login-wrap .login-margin,
  .notice-wrap .notice-box,
  .advantage-wrap .advantage-box,
  .promotion-wrap .promotion-padding,
  .joinus-wrap .joinus-padding {
    margin: auto 7.5%;
  }
}

@media (min-width: 992px) {
  /* .login-wrap .login-action {
    margin-right: 10%;
  } */
  .login-wrap .login-margin,
  .notice-wrap .notice-box,
  .advantage-wrap .advantage-box,
  .promotion-wrap .promotion-padding,
  .joinus-wrap .joinus-padding {
    margin: auto 10%;
  }
}

@media (min-width: 1200px) {
  /* .login-wrap .login-action {
    margin-right: 15%;
  } */
  .login-wrap .login-margin,
  .notice-wrap .notice-box,
  .advantage-wrap .advantage-box,
  .promotion-wrap .promotion-padding,
  .joinus-wrap .joinus-padding {
    margin: auto 15%;
  }
}

@media (min-width: 1400px) {
  /* .login-wrap .login-action {
    margin-right: 18.75%;
  } */
  .login-wrap .login-margin,
  .notice-wrap .notice-box,
  .advantage-wrap .advantage-box,
  .promotion-wrap .promotion-padding,
  .joinus-wrap .joinus-padding {
    margin: auto 18.75%;
  }
}

.swiper-wrap .swiper-container {
  position: relative;
  width: 100%;
}

.swiper-wrap .swiper-container .swiper-slide {
  width: 100%;
  text-align: center;
  padding-bottom: 40px;
}

.swiper-pagination {
  height: 22px;
  font-family: PingFangSC-Regular;
  color: #ff8622;
  letter-spacing: 0;
  bottom: 0;
}

.swiper-pagination-bullet {
  background: #ffffff;
  opacity: 1;
  height: 4px;
  width: 25px;
  border-radius: 2px;
  transition: all 0.2s;
}

.swiper-pagination-bullet-active {
  background: #ff8622;
}

.swiper-button-prev,
.swiper-button-next {
  color: #ff8622;
}

.contact-shadow {
  height: 100%;
  width: 100%;
  background-color: #626264;
  z-index: 100;
  -moz-opacity: 0.8;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
</style>
<style lang="less" scoped>
/* 产品与服务 */
.dialog-bg {
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background: #000000;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
}
.pop-wraps {
  background: #fff;
  width: 80%;
  max-width: 1200px;
  height: 676px;
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  .top {
    width: 100%;
    height: 56px;
    // background: #666666;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    padding: 0 20px;
    .title {
      font-size: 18px;
      color: #222;
    }
    .ca {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
  .banner-container {
    max-width: 1200px;
    // height: 300px;
    // background: pink;
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 20px 20px 20px 20px;
    .contents{
      width: 1200px;
      height: 180px;
      // position: relative;
      background: #fff;
      .banner-content{
        background-image: url(https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/pop_banner.png);
        background-repeat: no-repeat;
        height: 180px;
        // z-index: 99999 !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 40px 0 24px;
        .banner-content-l{
          .title{
            font-size: 40px;
            color: #FFFFFF;
            line-height: 56px;
            font-weight: 500;
            margin-bottom: 16px;
          }
          .text-s{
            font-size: 16px;
            color: #D4E6FD;
            line-height: 22px;
            margin-bottom: 8px;
            >span{
              margin-right: 7px;
            }
          }
          .text-t{
            font-size: 16px;
            color: #D4E6FD;
            line-height: 22px;
            >span{
              margin-right: 7px;
            }
          }
          .red{
            color: #d83354;
            font-weight: 700;
          }
        }
        .banner-content-r{
          display: flex;
          margin-top: 5px;
          .left{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 20px;
            .iamges{
              width: 120px;
              height: 120px;
              overflow: hidden;
              border-radius: 12px;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 100%;
                height: 100%;
              }
              .images1{
                  width: 90%;
                  height: 90%;
                }
            }
            .text{
              font-size: 14px;
              color: #fff;
              line-height: 20px;
              margin-top: 8px;
            }
          }
          .right{
            display: flex;
            flex-direction: column;
            align-items: center;
            .iamges{
              width: 120px;
              height: 120px;
              overflow: hidden;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .text{
              font-size: 14px;
              color: #fff;
              line-height: 20px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
  .dia-list{
    // background: pink;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .items{
      width: 23.5%;
      height: 170px;
      margin: 10px 0;
      border-radius: 4px;
      border: 1px solid #E8E8E8;
      padding: 16px;
      // background: orange;
      .tops{
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tops-img{
          width: 48px;
          height: 48px;
        }
        .tops-btn{
          width: 96px;
          height: 32px;
          background: #FF8622;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
        .tops-btn:hover{
          background: #fd933d;
        }
      }
      .botom{
        .botom-title{
          font-weight: 500;
          font-size: 16px;
          color: #222222;
          line-height: 22px;
          margin: 16px 0 8px 0;
        }
        .botom-text{
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 22px;
        }
      }
    }
    
  }
  .dia-list:after {
      content: "";
      width: 23.5%;
      height: 170px;
    }
}
.service-wrap {
  background: #ffffff;
  width: 80%;
  max-width: 1300px;
  height: 560px;
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);

  .flex-space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header {
    height: 56px;
    line-height: 56px;
    padding: 0 20px;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: #eeeeee;
    }

    .title {
      font-family: Alibaba-PuHuiTi-R;
      font-size: 18px;
      color: #222222;
    }

    img {
      width: 24px;
      cursor: pointer;
    }
  }
  .flex-space-around {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .body {
    padding: 80px 20px 71px;
  }

  .service-item {
    // padding: 40px 0;
    width: 250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // background: pink;
    img {
      width: 140px;
    }

    .title {
      margin: 20px 0;
      font-family: Alibaba-PuHuiTi-R;
      font-size: 24px;
      color: #222222;
      text-align: justify;
    }

    .sm-title {
      font-family: Alibaba-PuHuiTi-R;
      font-size: 14px;
      color: #666666;
      text-align: center;
      margin-bottom: 4px;
    }

    .btn-enter {
      margin-top: 20px;
      background: #ff8622;
      width: 144px;
      height: 36px;
      line-height: 36px;
      font-family: Alibaba-PuHuiTi-R;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      cursor: pointer;
    }
  }
}
.content-list {
  display: flex;
  flex-wrap: wrap;
}

.adv-img {
  width: 200px;
  height: 200px;
}
.zfb-bac {
  height: 320px;
  width: 160px;
  // padding: 0 40px;
  // margin-right: 40px;
}
.zfb-bac-image {
  width: 100%;
  height: 100%;
}
/* 产品与服务 */
</style>



// WEBPACK FOOTER //
// src/views/pc/home/Index.vue